/* Избранное + «Недавно просмотренные».
   Избранное хранится в приложении Swym Wishlist Plus (app embed включён в настройках темы),
   UI полностью свой: кнопки [data-favorite="<product.id>"] с data-variant-id и data-product-url.

   Устройство синхронизации:
   - клики работают сразу, не дожидаясь Swym: состояние зеркалится в localStorage
     (tmWishlistIds), операции пишутся в ПЕРСИСТЕНТНУЮ очередь (tmWishlistQueue,
     компактованную по товару — последняя операция побеждает) и переживают навигацию;
   - запись из очереди удаляется только после успешного ответа Swym; при ошибке
     операция доедет при следующей загрузке страницы;
   - при инициализации Swym серверное состояние сверяется с локальным: сервер — база,
     поверх — ещё не отправленные операции из очереди;
   - список для записи — 'My Wishlist' (или первый), удаление шлётся во все списки,
     где товар реально лежит; пустой список НЕ создаётся, пока нечего отправлять.

   «Недавние» — чистый localStorage (ключ recentlyViewed, совместим со старой темой).
   Страницы /pages/wishlist и /pages/recently-viewed: секция wishlist-grid рендерит все
   товары скрытыми, этот скрипт показывает нужные. */
(() => {
  if (window.__tmWish) return;
  window.__tmWish = true;

  const I18N = (document.currentScript && document.currentScript.dataset) || {};

  const lsRead = (key) => {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  };
  /* защита от мусора в легаси-ключах: только массив, иначе пусто */
  const lsArr = (key) => {
    const v = lsRead(key);
    return Array.isArray(v) ? v : [];
  };
  const lsSet = (key, val) => {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* приватный режим */ }
  };

  /* ---------- недавно просмотренные: запись на странице товара ---------- */
  const RV_KEY = 'recentlyViewed';
  const RV_MAX = 12;

  const handle = document.body.getAttribute('data-product-handle');
  if (handle) {
    const list = lsArr(RV_KEY).filter((h) => h !== handle);
    list.unshift(handle);
    lsSet(RV_KEY, list.slice(0, RV_MAX));
  }

  /* ---------- состояние избранного ---------- */
  const WL_KEY = 'tmWishlistIds';   /* зеркало итогового набора id */
  const Q_KEY = 'tmWishlistQueue';  /* { "<empi>": {a: adding, epi, du} } */

  const qRead = () => {
    const v = lsRead(Q_KEY);
    return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  };

  const state = {
    swat: null,
    listId: null,          /* куда добавляем */
    lists: null,           /* [{lid, ids:Set}] — серверный снимок для точечных удалений */
    ids: new Set(lsArr(WL_KEY).map(Number)),
    inflight: new Set(),   /* empi с запросом в полёте */
    creating: false,
    fetchTries: 0,
  };
  const mirror = () => lsSet(WL_KEY, [...state.ids]);

  /* ---------- страницы избранного/недавних: показать нужные карточки ---------- */
  const wrap = document.querySelector('[data-wl]');
  const grid = wrap ? wrap.querySelector('[data-wl-grid]') : null;
  const mode = grid ? grid.getAttribute('data-wl-grid') : null;

  const finish = (shown) => {
    wrap.classList.add('is-ready');
    wrap.classList.toggle('is-empty', shown === 0);
  };

  const revealWishlist = () => {
    if (mode !== 'wishlist') return;
    let shown = 0;
    grid.querySelectorAll('[data-product-id]').forEach((el) => {
      const show = state.ids.has(Number(el.getAttribute('data-product-id')));
      el.hidden = !show;
      if (show) shown++;
    });
    finish(shown);
  };

  const revealRecent = () => {
    if (mode !== 'recently') return;
    const order = lsArr(RV_KEY);
    let shown = 0;
    grid.querySelectorAll('[data-product-handle]').forEach((el) => {
      const i = order.indexOf(el.getAttribute('data-product-handle'));
      el.hidden = i < 0;
      if (i >= 0) { el.style.order = i; shown++; }
    });
    finish(shown);
  };

  /* ---------- отметка сердечек ---------- */
  const mark = () => {
    document.querySelectorAll('[data-favorite]').forEach((btn) => {
      const on = state.ids.has(Number(btn.getAttribute('data-favorite')));
      btn.classList.toggle('added', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  /* счётчик на сердечке в шапке — как у корзины */
  const favBadge = () => {
    const host = document.querySelector('.hdr__act--fav');
    if (!host) return;
    let b = host.querySelector('.hdr__fav-count');
    const n = state.ids.size;
    if (!n) { if (b) b.remove(); return; }
    if (!b) {
      b = document.createElement('span');
      b.className = 'hdr__cart-count hdr__fav-count';
      host.appendChild(b);
    }
    b.textContent = n > 99 ? '99+' : String(n);
  };

  const render = () => { mark(); revealWishlist(); favBadge(); };

  /* избранное показываем сразу из зеркала; Swym потом сверит с сервером */
  revealRecent();
  render();

  /* возврат из bfcache («назад» в Safari) и правки из другой вкладки */
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    state.ids = new Set(lsArr(WL_KEY).map(Number));
    render();
    trySync(); /* операции, накопленные на других страницах */
  });
  window.addEventListener('storage', (e) => {
    if (e.key !== WL_KEY) return;
    state.ids = new Set(lsArr(WL_KEY).map(Number));
    render();
  });

  /* ---------- тост в стиле сайта ---------- */
  let toastEl;
  let toastTimer;
  const toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tm-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    /* перезапуск анимации при повторном клике */
    toastEl.classList.remove('is-on');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 2200);
  };

  /* ---------- отправка очереди в Swym ---------- */
  /* удаляем товар из всех списков, где он реально лежит */
  const deleteEverywhere = (empi, epi, du, done) => {
    const holders = (state.lists || []).filter((l) => l.ids.has(empi));
    if (!holders.length) { done(true); return; } /* на сервере уже нет */
    let left = holders.length;
    let allOk = true;
    holders.forEach((l) => {
      state.swat.deleteFromList(
        l.lid,
        { empi: empi, epi: epi, du: du },
        () => { l.ids.delete(empi); if (--left === 0) done(allOk); },
        () => { allOk = false; if (--left === 0) done(allOk); }
      );
    });
  };

  const trySync = () => {
    if (!state.swat) return;
    const q = qRead();
    const keys = Object.keys(q);
    if (!keys.length) return;
    if (!state.listId) { ensureList(); return; }

    keys.forEach((k) => {
      if (state.inflight.has(k)) return;
      const op = q[k];
      const empi = Number(k);
      state.inflight.add(k);

      const done = (ok) => {
        state.inflight.delete(k);
        if (!ok) return; /* остаётся в очереди — доедет при следующей загрузке */
        const cur = qRead();
        /* убираем запись, только если пользователь не переиграл операцию,
           пока запрос был в полёте; иначе отправим новую следующим заходом */
        if (cur[k] && cur[k].a === op.a) {
          delete cur[k];
          lsSet(Q_KEY, cur);
        } else if (cur[k]) {
          trySync();
        }
      };

      if (op.a) {
        state.swat.addToList(
          state.listId,
          { empi: empi, epi: op.epi, du: op.du },
          () => {
            const main = (state.lists || []).filter((l) => l.lid === state.listId)[0];
            if (main) main.ids.add(empi);
            done(true);
          },
          () => done(false)
        );
      } else {
        deleteEverywhere(empi, op.epi, op.du, done);
      }
    });
  };

  /* список создаём лениво — только когда есть что отправлять */
  const ensureList = () => {
    if (state.listId || state.creating || !state.swat) return;
    if (!Object.keys(qRead()).length) return;
    state.creating = true;
    state.swat.createList(
      { lname: 'My Wishlist' },
      (l) => {
        state.creating = false;
        state.listId = l.lid;
        state.lists = [{ lid: l.lid, ids: new Set() }];
        trySync();
      },
      () => {
        /* вероятно, список уже существует (гонка вкладок) — перечитываем */
        state.creating = false;
        loadLists();
      }
    );
  };

  /* ---------- Swym готов: сверка с сервером + отправка очереди ---------- */
  const loadLists = () => {
    if (state.fetchTries >= 3) return;
    state.fetchTries++;
    state.swat.fetchLists({
      callbackFn: (lists) => {
        lists = lists || [];
        /* пишем в 'My Wishlist', если он есть, иначе в первый список */
        const named = lists.filter((l) => l.lname === 'My Wishlist')[0];
        state.listId = (named || lists[0] || {}).lid || null;
        state.lists = lists.map((l) => ({
          lid: l.lid,
          ids: new Set((l.listcontents || []).map((it) => Number(it.empi))),
        }));
        /* сервер — база, поверх — ещё не отправленные локальные операции */
        const server = new Set();
        state.lists.forEach((l) => l.ids.forEach((id) => server.add(id)));
        const q = qRead();
        Object.keys(q).forEach((k) => {
          if (q[k].a) server.add(Number(k)); else server.delete(Number(k));
        });
        state.ids = server;
        mirror();
        render();
        trySync();
      },
      errorFn: () => {
        /* транзиентный сбой — повторим; до тех пор работаем на локальном зеркале */
        setTimeout(loadLists, 3000 * state.fetchTries);
      },
    });
  };

  let swymHooked = false;
  const onSwym = (swat) => {
    if (swymHooked || !swat) return;
    swymHooked = true;
    state.swat = swat;
    loadLists();
  };

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwym);
  /* страховка: если Swym инициализировался ДО нашего скрипта, очередь колбэков
     уже обработана и push выше никогда не сработает — ловим _swat опросом */
  const swymPoll = setInterval(() => {
    if (swymHooked) { clearInterval(swymPoll); return; }
    if (window._swat && typeof window._swat.fetchLists === 'function') {
      clearInterval(swymPoll);
      onSwym(window._swat);
    }
  }, 400);
  setTimeout(() => clearInterval(swymPoll), 30000);

  /* ---------- клики: сразу, не дожидаясь Swym ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest ? e.target.closest('[data-favorite]') : null;
    if (!btn) return;
    e.preventDefault();
    const empi = Number(btn.getAttribute('data-favorite'));
    const adding = !state.ids.has(empi);

    if (adding) state.ids.add(empi); else state.ids.delete(empi);
    mirror();
    render();
    toast(adding ? (I18N.added || 'Added to wishlist') : (I18N.removed || 'Removed from wishlist'));

    /* компактование по товару: последняя операция побеждает */
    const q = qRead();
    q[String(empi)] = {
      a: adding,
      epi: Number(btn.getAttribute('data-variant-id')),
      du: location.origin + btn.getAttribute('data-product-url'),
    };
    lsSet(Q_KEY, q);
    trySync();
  });
})();
